import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { setSchoolData } from "../../../redux/slices/school/slice";

import client from "../client";
import handleApiError from "../../hooks/handleApiError";
import { selectSchoolDetails } from "../../../redux/slices/school/selectors";

export default function useFetchSchool() {
  const dispatch = useDispatch();
  const { schoolId } = useParams();

  const school = useSelector(selectSchoolDetails);
  const [loading, setLoading] = useState(false);

  const request = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const { data } = await client.get(`/school/${id}`);

        if (data?.success) {
          dispatch(setSchoolData(data?.data));
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleApiError(error);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (schoolId && !school) request(schoolId);
  }, [request, schoolId, school]);

  return { request, loading };
}
